import { useState, useEffect, useRef } from 'react';

import dayjs from 'dayjs';

export default function SecondKillModel({ secondKillProductVO }) {
  let daysView = 0;
  let hoursView = 0;
  let minutesView = 0;
  let secondsView = 0;
  const [days, setDays] = useState(daysView);
  const [hours, setHours] = useState(hoursView);
  const [minutes, setMinutes] = useState(minutesView);
  const [seconds, setSeconds] = useState(secondsView);
  // const [progressPercent] = useState(
  //   ((secondKillProductVO?.productOccupyNumber / secondKillProductVO?.productTotalNumber) * 100).toFixed(0),
  // );

  const timer = useRef(null);

  const RefreshTime = () => {
    const targetDate = secondKillProductVO?.validEndTime || '2024-08-24 23:59:59';
    const nowTime = dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).toDate();
    const end = dayjs(targetDate).toDate();
    const sec = dayjs(end).diff(dayjs(nowTime), 'second');
    if (sec < 0) {
      // 清除定时器
      timer.current && clearInterval(timer.current);
      setDays(() => '00');
      setHours(() => '00');
      setMinutes(() => '00');
      setSeconds(() => '00');
      return;
    }
    daysView = Math.floor(sec / (60 * 60 * 24)).toString();
    hoursView = Math.floor((sec - daysView * 24 * 60 * 60) / 3600).toString();
    minutesView = Math.floor((sec - daysView * 24 * 60 * 60 - hoursView * 3600) / 60).toString();
    secondsView = Math.floor(sec - daysView * 24 * 60 * 60 - hoursView * 3600 - minutesView * 60).toString();
    setDays(() => daysView);
    setHours(() => hoursView);
    setMinutes(() => minutesView);
    setSeconds(() => secondsView);
  };

  useEffect(() => {
    RefreshTime();
    timer.current = setInterval(() => {
      RefreshTime();
    }, 1000);
    return () => {
      clearInterval(timer.current);
    };
  }, []);

  return (
    <>
      <p className="text-[14px] text-[#444] w-[300px]">
        剩余 <span className="text-[16px] bold">{`${days}天${hours}小时${minutes}分${seconds}秒`}</span> 结束
      </p>
      <div className="bg-[#f9f9f9] text-[12px] text-[#9999] mt-[20px] p-[10px] leading-[24px]">
        <ul className="flex">
          <li className="flex-1">
            秒杀特价：<span className="text-[#ff7800]">￥{secondKillProductVO?.secondKillPrice}</span>
          </li>
          <li className="flex-1">
            货期：
            <span className="text-[#444]">
              结束后{secondKillProductVO?.productDeliveryDay - 1}-{secondKillProductVO?.productDeliveryDay + 1}
              工作日
            </span>
          </li>
        </ul>
        <ul className="flex">
          <li className="flex-1">
            起订量：<span className="text-[#444]">{secondKillProductVO?.minPurchaseNumber}</span>
          </li>
          <li className="flex-1">
            剩余库存:
            <span className="text-[#444] ml-[5px]">
              {secondKillProductVO?.productTotalNumber - secondKillProductVO?.productOccupyNumber}
            </span>
            {/* <div className="w-[102px] h-[5px] border-[1px] rounded-[7px] bg-[#DEDEDE] inline-block">
              {progressPercent && (
                <Popover
                  content={`剩余库存 ${secondKillProductVO?.productTotalNumber - secondKillProductVO?.productOccupyNumber}`}
                  placement="bottom"
                  trigger="hover"
                >
                  <div
                    style={{ width: `${Math.ceil(progressPercent)}px` }}
                    className={` h-[5px] rounded-[7px] bg-gradient-to-r from-[#ffff] to-[#0093E6]`}
                  ></div>
                </Popover>
              )}
            </div> */}
          </li>
        </ul>
      </div>
    </>
  );
}
